<template>
  <div class="container">
    <div class="banner">
      <img src="../assets/personbg.png" />
      <img src="../assets/banner_img.png" />
    </div>
    <div class="getTime">
      <div class="appointment">
        <div>请选择预约门票时间</div>
        <!--<div>{{month}}月</div>-->
      </div>
      <Calendar v-on:choseDay="clickDay"></Calendar>
      <div v-if="registrationEnd != ''" class="registrationEnd">
        {{ registrationEnd }}
      </div>
      <ul v-else="" class="personal_site">
        <li
          v-if="item.ticketnums > 0"
          :class="
            activeClass == index ? 'personal_site_red' : 'personal_site_white'
          "
          v-for="(item, index) in details"
          @click="changeli_site(item, index)"
        >
          <div>{{ item.name }}</div>
          <div>
            (余票：<span>{{ item.ticketnums }}</span
            >)
          </div>
        </li>
        <li v-else="" class="personal_site_white">
          <div>{{ item.name }}</div>
          <div>(已约满)</div>
        </li>
      </ul>
      <div class="personal_btn" @click="next_cli">下一步</div>
    </div>
    <div class="per_yy" v-if="persom">
      <div class="per_gs">
      <div style="    text-align: center;font-size: 20px;margin-bottom: 9px;">温馨提示<br /> </div >
      <div class="per_ne">
<!--        
&nbsp&nbsp&nbsp&nbsp 疫情防控，人人有责，感谢您的理解与配合。<br/>
&nbsp&nbsp&nbsp&nbsp根据北京市疫情防控工作要求，香山革命纪念馆依据“限量、预约、错峰”原则，按照75%限流开放，暂停团体预约、人工讲解服务及聚集性活动。提示如下：<br/>
&nbsp&nbsp&nbsp&nbsp 1. 参观时间：9:00—16:30（16:00后停止入馆，每周一闭馆）<br/>
&nbsp&nbsp&nbsp&nbsp2. 参观预约：观众参观本馆，均需提前通过香山革命纪念馆官网或官方微信订阅号进行实名预约，按照预约时段来馆参观，避免扎堆聚集。<br/>
&nbsp&nbsp&nbsp&nbsp3.参观流程：根据北京市疫情防控要求，7日内有过中高风险地区旅居史或与确诊病例活动轨迹重合，以及伴有发热咳嗽、恶心呕吐、呼吸困难、腹泻腹痛、嗅觉味觉减退等身体不适人员谢绝到馆参观。所有入馆观众需提供72小时核酸阴性证明。入馆后听从工作人员引导、全程科学佩戴口罩，保持安全距离，谢绝聚集性拍照、集体宣誓等活动，如遇身体不适等情况，请及时联系工作人员。 疫情防控，人人有责，感谢您的理解与配合。

    -->
  &nbsp&nbsp&nbsp&nbsp 为落实国家疫情防控相关优化措施和北京市疫情防控总体部署和要求，香山革命纪念馆按照75%预约观众限流开放，为确保您在纪念馆安全、健康、有序参观，请注意以下事项：<br/>
1.请您提前安排参观时间，通过纪念馆官网或官方微信订阅号进行实名预约，分时段来馆参观，参观时保持安全距离，避免扎堆聚集。<br/>
2.入馆参观前，请您配合馆内工作人员进行体温测量。如有体温≥37.3℃等异常情况将谢绝入馆。<br/>
3.入馆后身体如有不适，请及时联系工作人员。<br/>
4.纪念馆暂不提供人工讲解服务，为保障您的观展体验，您可扫描展柜上的二维码收听语音讲解，为避免影响其他观众，请您佩戴耳机收听。<br/>
5.您可以通过微信公众号“观·展览”菜单栏中的“数字展厅”栏目在线观展。<br/>
感谢您的理解与配合，祝您参观愉快。
    
      </div>
     
        <div class="personal_bse" @click="persomse">确定</div>
      </div>
    </div>
    
    <div class="appointment_success" v-show="success">
      <div class="success_center">
        <img v-if="success_img" src="../assets/success.png" />
        <img v-if="!success_img" src="../assets/buttom_x.png" />
        <p>{{ success_text }}</p>
        <div @click="determine">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { wclient } from "../../static/wclient-mobile.js";
import Calendar from "vue-calendar-component";
export default {
  nama: "Usage",
  data() {
    return {
      year: "",
      month: "",
      day: "",
      opentimecustomlist: [],
      details: [],
      activeClass: -1,
      appointmenttime: "",
      success: false,
      success_img: false,
      success_text: "",
      site_name: "",
      paragraphid: "",
      registrationEnd: "",
      today: "",
      baseUrl: "",
      outtime: "",
      thisTime: "",
      ticketcodelist: [],
      persom:true
    };
  },
  components: {
    Calendar,
  },
  methods: {
    persomse(){
      this.persom=!this.persom
    },
    clickDay(data) {
      var that = this;
      that.activeClass = -1;
      that.year = data.split("/")[0];
      that.month = data.split("/")[1];
      that.day = data.split("/")[2];
      if (that.month < 10) {
        that.month = "0" + that.month;
      }
      if (that.day < 10) {
        that.day = "0" + that.day;
      }
      var today_cli = that.year + "-" + that.month + "-" + that.day;
      if (that.ordertype == "0") {
        if (
          new Date(that.today).getTime().toString() >
          new Date(today_cli).getTime().toString()
        ) {
          that.registrationEnd = "门票预约已经结束";
        } else {
          for (var i = 0; i < that.opentimecustomlist.length; i++) {
            if (today_cli == that.opentimecustomlist[i].time) {
              that.details = that.opentimecustomlist[i].details;
              that.appointmenttime = that.opentimecustomlist[i].time;
              that.registrationEnd = "";
              if (that.opentimecustomlist[i].status == "0") {
                that.registrationEnd = "闭馆";
              }
              return;
            } else {
              if (
                new Date(that.today).getTime().toString() ==
                new Date(today_cli).getTime().toString()
              ) {
                that.registrationEnd = "不可预约";
              } else {
                that.registrationEnd = "门票预约暂未开始";
              }
            }
          }
        }
      } else if (that.ordertype == "1") {
        if (
          new Date(that.today).getTime().toString() >
          new Date(today_cli).getTime().toString()
        ) {
          that.registrationEnd = "门票预约已经结束";
        } else {
          for (var i = 0; i < that.opentimecustomlist.length; i++) {
            if (today_cli == that.opentimecustomlist[i].time) {
              that.details = that.opentimecustomlist[i].details;
              that.appointmenttime = that.opentimecustomlist[i].time;
              that.registrationEnd = "";
              if (that.opentimecustomlist[i].status == "0") {
                that.registrationEnd = "闭馆";
              }
              return;
            } else {
              if (
                new Date(that.today).getTime().toString() ==
                new Date(today_cli).getTime().toString()
              ) {
                that.registrationEnd = "不可预约";
              } else {
                that.registrationEnd = "门票预约暂未开始";
              }
            }
          }
        }
      }
    },
    changeli_site(item, index) {
      var that = this;
      that.activeClass = index;
      that.site_name = item.name;
      that.outtime = item.outtime;
      that.paragraphid = item.paragraphid;
    },
    next_cli() {
      var that = this;
      var timer = new Date();
      var year = timer.getFullYear();
      var month = timer.getMonth() + 1;
      var day = timer.getDate();
      var hour = timer.getHours();
      var minutes = timer.getMinutes();
      var thisSecond = parseInt(hour) * 60 * 60 + parseInt(minutes) * 60;
      var cliSecond =
        parseInt(that.outtime.split(":")[0]) * 60 * 60 +
        parseInt(that.outtime.split(":")[1]) * 60;
      if (that.activeClass == -1) {
        that.success = true;
        that.success_img = false;
        that.success_text = "请选择预约时间";
      } else if (
        that.appointmenttime == that.today &&
        parseInt(thisSecond) > parseInt(cliSecond)
      ) {
        that.success = true;
        that.success_img = false;
        that.success_text = "您所选日期不能预约，请重新选择！";
      } else {
        sessionStorage.removeItem("ticketcodelist");
        sessionStorage.removeItem("license");
        that.$http
          .get(
            that.baseUrl +
              "/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c",
            {}
          )
          .then(function (res) {
            sessionStorage.setItem(
              "imageurl",
              res.data.activitylist[0].imageurl
            );
            sessionStorage.setItem("title", res.data.activitylist[0].title);
            sessionStorage.setItem("site_name", that.site_name);
            sessionStorage.setItem("appointmenttime", that.appointmenttime);
            sessionStorage.setItem("summary", res.data.activitylist[0].summary);
            sessionStorage.setItem("paragraphid", that.paragraphid);
            sessionStorage.setItem("e", 0);
            if (res.data.code == "A00006") {
              sessionStorage.setItem(
                "ticketcodelist",
                JSON.stringify(that.ticketcodelist)
              );
              that.$router.push({
                name: "Information",
              });
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    determine() {
      var that = this;
      that.success = false;
    },
  },
  mounted() {
    var that = this;
    let time = new Date();
    that.month = time.getMonth() + 1;
    var publicUrl = window.location.hostname;
    that.taid = sessionStorage.getItem("taid");
    var taid = sessionStorage.getItem("taid");
    if (publicUrl == "localhost") {
     var baseUrl = "https://www.xiangshan1949.cn";
    } else if (publicUrl == "m.xs.weapi.org") {
      var baseUrl = "https://www.xiangshan1949.cn";
    } else {
      var baseUrl = "https://www.xiangshan1949.cn";
    }
    that.baseUrl = baseUrl;
    wclient.view.showLoading();
    that.ordertype = sessionStorage.getItem("orderType");
    if (that.ordertype == "0") {
      var type = "个人";
      that.ticketcodelist = [
        {
          realname: sessionStorage.getItem("RegistrantName"),
          idcard: sessionStorage.getItem("RegistrantIdNumber"),
          telnum: "",
          certificate_type: "idcard",
          userstatus: "",
          show: false,
          childnum: "",
          childidcard: [],
        },
      ];
    } else if (that.ordertype == "1") {
      var type = "旅行";
      that.ticketcodelist = [
        {
          realname: sessionStorage.getItem("RegistrantName"),
          idcard: sessionStorage.getItem("RegistrantIdNumber"),
          telnum: sessionStorage.getItem("RegistrantPhone"),
          certificate_type: "idcard",
          userstatus: "",
          show: false,
          childnum: "",
          childidcard: [],
        },
      ];
    }
    that.$http
      .get(
        that.baseUrl +
          "/tickets/tickets/ajax?ugi=bookingticket&action=bookingTime&moduleid=TICKETS&taid=" +
          taid +
          "&type=" +
          type,
        {}
      )
      .then(function (res) {
        wclient.view.hideLoading();
        that.opentimecustomlist = res.data.opentimecustomlist;
        var timer = new Date();
        var year = timer.getFullYear();
        var month = timer.getMonth() + 1;
        var day = timer.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        that.today = year + "-" + month + "-" + day;
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
</script>

<style scoped>
.per_ne{
  height: 60vh;
    overflow-y: auto;
}
.per_yy{
    position: fixed;
    top: 0;
    bottom: 0;
    background: #00000070;
    width: 100%;
        display: flex;
    align-items: center;
    justify-content: center;
}
.per_gs{
    width: 80%;
    background: #fff;
    padding: 23px 5%;
    border-radius: 10px;
}
.personal_bse{
    width: 70%;
    margin: 20px auto 10px;
    background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
    color: rgba(254, 254, 254, 1);
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    border-radius: 40px;
}

.container {
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.banner {
  width: 100%;
  position: relative;
}

.banner img {
  width: 100%;
}

.banner img:nth-child(2) {
  position: absolute;
  width: 80%;
  bottom: 0;
  left: 10%;
  height: 55%;
  border-radius: 10px;
}

.getTime {
  width: 90%;
  padding: 0 5%;
}

>>> .wh_container {
  width: 100%;
  border-radius: 50px;
}

>>> .wh_jiantou1 {
  border-top: 2px solid rgba(70, 70, 70, 1) !important;
  border-left: 2px solid rgba(70, 70, 70, 1) !important;
}

>>> .wh_jiantou2 {
  border-top: 2px solid rgba(70, 70, 70, 1) !important;
  border-left: 2px solid rgba(70, 70, 70, 1) !important;
  transform: rotate(130deg) !important;
}

>>> .wh_top_changge li {
  color: rgba(70, 70, 70, 1) !important;
}

>>> .wh_content_all {
  background: white !important;
}

>>> .wh_content_item {
  color: rgba(70, 70, 70, 1) !important;
}

>>> .wh_content_item .wh_chose_day {
  background: rgba(222, 75, 67, 1) !important;
  color: white !important;
}

>>> .wh_item_date {
  background: white !important;
}

.appointment {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 50px;
  color: rgba(70, 70, 70, 1);
}

.personal_time {
  border-radius: 15px;
  float: left;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
}

.personal_time img {
  width: 10px;
}

.registrationEnd {
  width: 100%;
  line-height: 72px;
  text-align: center;
  margin-top: 30px;
}

.personal_site {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.personal_site_white {
  float: left;
  width: 47%;
  height: 62px;
  background: url(../assets/site_white.png) center center no-repeat;
  background-size: contain;
  padding-top: 10px;
  color: #acb2b6;
}

.personal_site_red {
  float: left;
  width: 47%;
  height: 62px;
  background: url(../assets/site_red.png) center center no-repeat;
  background-size: contain;
  padding-top: 10px;
  color: #e40404;
}

.personal_site > li div {
  width: 100%;
  float: left;
  text-align: center;
  line-height: 20px;
}

.personal_site > li div:nth-child(1) {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 500;
}

.personal_site > li div:nth-child(2) {
  font-size: 12px;
}

.personal_btn {
  width: 70%;
  margin: 10px auto 30px;
  background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
  color: rgba(254, 254, 254, 1);
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  border-radius: 40px;
}

.appointment_success {
  width: 110%;
  height: 100%;
  background: rgba(0, 0, 0, 0.54);
  position: fixed;
  top: 0;
  left: 0;
}

.success_center {
  margin-top: 35%;
  background: white;
  width: 60%;
  margin-left: 15%;
  padding-top: 10px;
  border-radius: 10px;
}

.success_center img {
  width: 25%;
  margin-left: 37%;
  margin-top: 30px;
}

.success_center p:nth-of-type(1) {
  width: 90%;
  color: black;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin: 20px auto 0;
}

.success_center p:nth-of-type(2) {
  width: 100%;
  color: #a4a4a4;
  font-size: 16px;
  text-align: center;
  margin-top: 5px;
  letter-spacing: 1px;
}

.success_center div {
  width: 100%;
  line-height: 45px;
  text-align: center;
  font-weight: 600;
  color: rgba(228, 4, 4, 1);
  border-top: 1px solid #eee;
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/personal.vue